import { T } from '../../i18n';
import { Services } from '../../services/index';
import { CurrentState } from '../../state/page.state';
import { AppStore } from '../../store';
import { CollectionStatusModal } from '../collection.status.modal/collection.status.modal';

export const CollectionSetStatusCtrl = {
	// if at least one selected collection's form has state metadata and the user is neither Viewer nor Downloader
	canDisplay(): boolean {
		const userProfile = Services.UserProfile.get(Services.User.current.objectId);
		if (
			!Services.UserProfile.isDepartmentViewer(userProfile) &&
			!Services.UserProfile.isDepartmentDownloader(userProfile)
		) {
			for (const summary of CurrentState.Tag.collections) {
				const formSummary = AppStore.FormSummary.get(summary.formRevision);
				if (formSummary != null && formSummary.metadata != null && formSummary.metadata.status != null) {
					return true;
				}
			}
		}
		return false;
	},

	canSetStatus(): boolean {
		if (!CollectionSetStatusCtrl.canDisplay()) {
			return false;
		}

		return true;
	},

	showSetStatusModal(): void {
		const collections = CurrentState.Tag.collections;
		const modal: CollectionStatusModal = new CollectionStatusModal(
			{
				title: T.COLLECTION_STATUS_TITLE,
				confirm: () => (modal.statusSelector.inputState.value ? T.COLLECTION_STATUS : T.CLEAR_COLLECTION_STATUS),
				success: {
					key: T.COLLECTION_STATUS_SUCCESS,
					attrs: {
						count: collections.length,
					},
				},
			},
			collections
		);

		modal.open();
	},
};
